import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ICLoading } from "../Icon/ICLoading";

interface SpinnerLoadingProps {
  className?: string;
  size?: number;
  logoClassName?: string;
}

export default function SpinnerLoading({
  className,
  size = 100,
  logoClassName,
}: SpinnerLoadingProps) {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prev) => (prev + 3) % 360);
    }, 10);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      className={className}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
      }}
    >
      {/* Gradient spinner */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          borderRadius: "80%",
          background:
            "conic-gradient(from 0deg, transparent 0%, #10B981 30%, #10B981 60%, transparent 90%)",
          transform: `rotate(${rotation}deg)`,
        }}
      />

      {/* Border mask to create ring effect */}
      <Box
        sx={{
          position: "absolute",
          width: "calc(100% - 10px)",
          height: "calc(100% - 10px)",
          backgroundColor: "black",
          borderRadius: "50%",
        }}
      />

      {/* Center logo */}
      <Box
        className={logoClassName}
        sx={{
          position: "relative",
          zIndex: 10,
        }}
      >
        <ICLoading width={`${size * 0.6}`} height={`${size * 0.6}`} />
      </Box>
    </Box>
  );
}
